import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

import {clearErrors} from '../../../../../actions/erroractions';
import {setIsModalOpen} from '../../../../../actions/AccessGroups/SetIsModalOpen';

import EditEntityForm from './EditEntityForm/index';

const EditEntityModal = ({entity, project, showModal, setShowModal}) => {
	const [isLoading, setIsLoading] = useState(false);

	const dispatch = useDispatch();

	const setModalErrors = (val) => dispatch(clearErrors()).then(() => dispatch(setIsModalOpen(val)));

	const hideModal = () => {
		setShowModal(false);
		setModalErrors(false);
	};

	const renderModal = () => {
		const props = {
			entity,
			project,
			showModal,
			hideModal
		};

		return <EditEntityForm {...props} />;
	};

	return <>{showModal && renderModal()}</>;
};

export default EditEntityModal;
